import { useCampaignStore } from '@lidea/shared/data-access/core';
import { plotKeys } from '@lidea/shared/data-access/plots';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { zoningApi } from '../../apis/zoning-api';
import { analysisKeys } from '../../keys/analysis-keys';

export interface UseGenerateZoningProps {
  plotId: number;
} 
export interface GenerateZoningMutationData {
  imageryIndex: string;
  imageDate: string;
  analysisId: number;
  zoneNumber: string;
}

export function useGenerateZoning(props: UseGenerateZoningProps) {
  const queryClient = useQueryClient();
  const campaignId = useCampaignStore((s) => s.campaignId);

  const mutation = useMutation({
    mutationFn: (data: GenerateZoningMutationData) =>
      zoningApi.generateZoning(
        data.imageryIndex,
        data.imageDate,
        data.analysisId,
        data.zoneNumber
      ),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: plotKeys.detail(props.plotId, campaignId).queryKey,
      });
      queryClient.invalidateQueries({
        queryKey: analysisKeys.zoning(variables.analysisId).queryKey,
      });
    },
  });

  return mutation;
}

export default useGenerateZoning;
